import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IManagerBonusClientDaily } from '@entities/managersPerformance/IManagerBonus';

export const fetch = async ({
  managerId,
  month,
  year,
  clientId,
}: {
  month: number;
  year: number;
  managerId: number;
  clientId: number;
}): Promise<IManagerBonusClientDaily[]> => {
  const response = await api.get<IManagerBonusClientDaily[]>(
    `${BI_BASE_URL}/managers/manager/${managerId}/bonus/${month}/client/${clientId}`,
    { params: { year } }
  );

  return response.data ?? [];
};

export const useManagerBonusClientDaily = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
